import { render } from "./results-list.vue?vue&type=template&id=45a84eaa&scoped=true"
import script from "./results-list.vue?vue&type=script&lang=js"
export * from "./results-list.vue?vue&type=script&lang=js"

import "./results-list.vue?vue&type=style&index=0&id=45a84eaa&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a84eaa"]])

export default __exports__